import { render, staticRenderFns } from "./priceCus.vue?vue&type=template&id=a4179e30&"
import script from "./priceCus.vue?vue&type=script&lang=js&"
export * from "./priceCus.vue?vue&type=script&lang=js&"
import style0 from "./priceCus.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports